export function cleanCategorySubheader (categories) {
  const existingSubheaders = categories.filter(c => c.categoryType === 'SUBHEADER')
  if (existingSubheaders.length > 1) {
    const existingSubheaderIndex = existingSubheaders.findIndex(s => !s.$added)
    categories[existingSubheaderIndex].categoryType = 'SUBHEADER_UNUSED'
  }
}
